import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Table } from '~/components/blocks';
import { settingsDrawerState } from '~/state/settings_systemsettings/atoms';

export const Checkin = () => {
  const set = useSetAtom(settingsDrawerState);

  const handleClick = useCallback(() => {
    set({ drawer: 'checkin' });
  }, [set]);

  return (
    <>
      <Table.Tr onClick={handleClick}>
        <Table.Td>店舗チェックイン</Table.Td>
      </Table.Tr>
    </>
  );
};
